// Only `;base64,` data URIs are decodable here. A syntactically legal
// `data:image/...` src can still carry a non-base64 payload (e.g.
// `data:image/svg+xml;utf8,<svg ...>`), or a corrupted base64 payload —
// both must fail safely (return `null`) instead of throwing, since callers
// invoke this synchronously from paste/drop handling paths (Quill's
// clipboard `Clipboard.convert`, and `handleChange`'s `normalizeDataImages`)
// where an uncaught throw would abort the whole paste, or worse, permanently
// break `onChange` for the field.
export const dataUriToBlob = (
  dataUri: string
): { blob: Blob; extension: string } | null => {
  const [meta, base64] = dataUri.split(",");
  const match = /^data:(.*?);base64$/.exec(meta ?? "");
  if (!match || !base64) {
    return null;
  }
  const mime = match[1] || "image/png";
  try {
    const byteString = atob(base64);
    const bytes = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i += 1) {
      bytes[i] = byteString.charCodeAt(i);
    }
    return {
      blob: new Blob([bytes], { type: mime }),
      // `image/svg+xml` → `svg`, `image/x-icon` → `icon`
      extension: (mime.split("/")[1] || "png")
        .replace(/\+xml$/, "")
        .replace(/^x-/, ""),
    };
  } catch {
    // Malformed base64 payload (atob throws `InvalidCharacterError`).
    return null;
  }
};
